import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { HomePageURL } from '../assets/const';
import TeamList from '../pages/team/TeamList';


export default class TeamRoute extends React.Component{
    render(){
        return (
            <Routes>
                <Route path={`${HomePageURL}/team/`} element={<TeamList/>} />
                {/* <Route path={`${HomePageURL}/stores/visits/`} element={<StoreVisits/>} />
                <Route path={`${HomePageURL}/stores/orders/`} element={<StoreOrders/>} />
                <Route path={`${HomePageURL}/stores/:storeSlug/`} element={<StoreDetail/>} /> */}
            </Routes>
            
        )
    }
}